import React from 'react';
import TableRow from './table_row.jsx'
import TableEditableRow from './table_editable_row.jsx'
import { withTranslation, Trans } from 'react-i18next';

export default class TableBody extends React.Component {
    render() {
        let isEmpty = this.props.items.length === 0;
        return (
            <tbody>
            {
                    this.props.items.map(
                        (item, index) => {
                            const key = this.props.keyField ? item[this.props.keyField] : index;
                            return (
                                <TableEditableRow
                                    key={ key }
                                    columns={ this.props.columns }
                                    item={ item }
                                    isEditable={ this.props.isEditable }
                                    isEditableRow={ this.props.isEditableRows }
                                    canBeRemoved={ this.props.canBeRemoved }
                                    removeItemFunction={ this.props.removeItemFunction }
                                    editItemFunction={ this.props.editItemFunction }
                                    rowStyle={(typeof this.props.rowStylePrepare === 'function') ? this.props.rowStylePrepare(item) : {}} />);
                        })
            }
            </tbody>
       );
    }
}